<header id="header">

    <mat-toolbar color="primary">
        <button mat-icon-button (click)="onSideNavToggle()">
            <mat-icon>menu</mat-icon>
        </button>

        <span>{{ 'Tapgo' | translate }}</span>

        <span class="spacer"></span>

        <app-language-switcher></app-language-switcher>
        <span class="spacer"></span>


        <div class="search-box" *ngIf="!mobileMode">
            <mat-icon>search</mat-icon>
            <input type="text" placeholder="{{ 'Search' | translate }}" />
        </div>
        <button mat-icon-button matTooltip="Mail" [matMenuTriggerFor]="notification" class="ml-3">
            <mat-icon>notifications</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-3">
            <img class="profile-pic" src="assets/images/profile.jpg" />
        </button>
    </mat-toolbar>

    <!-- profile menu -->
    <mat-menu #menu="matMenu" xPosition="before" class="menu bg-app">
        <button mat-menu-item routerLink="user-profile">
            <mat-icon>person</mat-icon>
            <span>{{ 'Profile' | translate }}</span>
        </button>
        <button mat-menu-item routerLink="cms">
            <mat-icon>settings</mat-icon>
            <span>{{ 'Settings' | translate }}</span>
        </button>
        <button mat-menu-item routerLink="">
            <mat-icon>power_settings_new</mat-icon>
            <span>{{ 'Log Out' | translate }}</span>
        </button>
    </mat-menu>

    <!-- notification menu -->
    <mat-menu #notification="matMenu" xPosition="before" class="menu custom-scrollbar bg-app notification-menu">
        <app-notification-menu></app-notification-menu>
    </mat-menu>

</header>